const $inject = ["$scope", "$stateParams"];

class MenuController {
  constructor($scope, $stateParams) {
    $scope.title = $stateParams.title;
    $scope.menu_tab = $stateParams.menu_tab;
  }
}

MenuController.$inject = $inject;
export default MenuController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/admin/controllers/menu.controller.js
 **/